import React from 'react';
import { CheckIcon } from 'lucide-react';
import { PageHeader } from '../components/PageHeader';
import { Section } from '../components/Section';
import { Reveal } from '../components/Reveal';
import { ClosingCTA } from '../components/ClosingCTA';
import { LinkButton } from '../components/Button';
import { services } from '../data/services';
export function Services() {
  return <main data-id="element-408" data-mp="15v9la9es3if">
      <PageHeader eyebrow="Services" title="Five practices, coordinated by one adviser." lede="Families rarely have an investment problem in isolation. What follows is the full scope of what we take responsibility for — and who each practice is genuinely for." data-id="element-409" data-mp="15bzgfq02jey">
        <LinkButton to="/contact" data-id="element-410" data-mp="657uhpgpz0id">Book a consultation</LinkButton>
      </PageHeader>

      <Section data-id="element-411" data-mp="2cvebc2ibsrch">
        <div className="divide-y divide-line" data-id="element-412" data-mp="2cuw5ce5v2yrd">
          {services.map((service, index) => <Reveal key={service.slug} delay={index * 0.04} className="py-12 first:pt-0 last:pb-0" data-id="element-413" data-mp="27wkvw4jhaq9o" data-mpi={index}>
              <div className="grid gap-8 lg:grid-cols-12 lg:gap-12" data-id="element-414" data-mp="16p2tm6p7fjyu">
                <div className="lg:col-span-5" data-id="element-415" data-mp="16mzwz3tjqsl5">
                  <span className="font-sans text-overline font-semibold uppercase text-gold-dark" data-id="element-416" data-mp="1boz1wi4xpxk7">
                    0{index + 1}
                  </span>
                  <h2 className="mt-4 font-serif text-h2 text-charcoal" data-id="element-417" data-mp="1fnoei8i5fb2s">{service.title}</h2>
                  <p className="mt-4 text-[1.0625rem] leading-relaxed text-charcoal-600" data-id="element-418" data-mp="1ki2c8hka9uam">
                    {service.what}
                  </p>
                </div>

                <div className="lg:col-span-4" data-id="element-419" data-mp="1ucu7vfub272r">
                  <h3 className="font-sans text-overline font-semibold uppercase text-charcoal-400" data-id="element-420" data-mp="1zdrq1sfbf149">
                    Who it&apos;s for
                  </h3>
                  <p className="mt-4 text-[0.95rem] leading-relaxed text-charcoal-600" data-id="element-421" data-mp="23eaj1psy2d81">
                    {service.who}
                  </p>
                </div>

                <div className="lg:col-span-3" data-id="element-422" data-mp="923xbx2fce1h">
                  <h3 className="font-sans text-overline font-semibold uppercase text-charcoal-400" data-id="element-423" data-mp="92vsj6s409r8">
                    What&apos;s included
                  </h3>
                  <ul className="mt-4 space-y-2.5" data-id="element-424" data-mp="17e6pet6cypcl">
                    {service.includes.map(item => <li key={item} className="flex gap-2.5 text-[0.925rem] leading-snug text-charcoal-600" data-id="element-425" data-mp="1le7pw7ipnurj">
                        <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-426" data-mp="1hd5rfswmbmqm" />
                        {item}
                      </li>)}
                  </ul>
                </div>
              </div>
            </Reveal>)}
        </div>
      </Section>

      <ClosingCTA eyebrow="Not sure where to start" title="Most families begin with a portfolio review." body="We read what you already hold, tell you what we would keep, and only then talk about anything new." data-id="element-427" data-mp="252q9m9ky6fyu" />
    </main>;
}